import Cookies from 'js-cookie';

/**
 * Persists the normal/condensed choice made from the user menu. Condensed trades
 * whitespace for content across the whole app, which matters to users running
 * Windows display scaling at 125% or working on a smaller screen.
 *
 * Deliberately global rather than per page: it describes the screen the user is
 * on, not the table they are looking at. Mirrors themePreference, down to the
 * class on <html> - a stopgap until there is a real user-preferences screen, at
 * which point only this module changes.
 */
const DENSITY_COOKIE = 'cas_density';
const CONDENSED = 'condensed';
const NORMAL = 'normal';

/** The class the condensed rules in app.css hang off, on <html> like the dark theme. */
const CONDENSED_CLASS = 'cas-condensed';

const ONE_YEAR_IN_DAYS = 365;

/** Reads the stored choice. Falls back to normal, which is what the app did before. */
export const isCondensedStored = (): boolean => Cookies.get(DENSITY_COOKIE) === CONDENSED;

/** Applies the density to <html>. Safe to call before React mounts. */
export const applyDensity = (isCondensed: boolean): void => {
  document.documentElement.classList.toggle(CONDENSED_CLASS, isCondensed);
};

export const saveDensityPreference = (isCondensed: boolean): void => {
  Cookies.set(DENSITY_COOKIE, isCondensed ? CONDENSED : NORMAL, {
    expires: ONE_YEAR_IN_DAYS,
    sameSite: 'strict',
    // Unlike the auth cookies this one is not sensitive, and hard-coding `secure`
    // would stop it persisting when the app is served over plain http in dev.
    secure: window.location.protocol === 'https:'
  });
};
